var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      attrs: { temporary: "", right: "", app: "", width: "400" },
      model: {
        value: _vm.localDrawer,
        callback: function ($$v) {
          _vm.localDrawer = $$v
        },
        expression: "localDrawer",
      },
    },
    [
      _c("v-card", { staticClass: "pt-4 elevation-0" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-end hidden-md-and-up" },
          [
            _c(
              "v-btn",
              {
                staticClass: "ma-1",
                attrs: {
                  "x-small": "",
                  outlined: "",
                  fixed: "",
                  fab: "",
                  right: "",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    _vm.localDrawer = false
                  },
                },
              },
              [
                _c("v-icon", { attrs: { small: "" } }, [
                  _vm._v(" fas fa-times "),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-toolbar",
        { attrs: { flat: "" } },
        [
          _c(
            "v-list-item",
            {
              staticClass: "pa-0 font-weight-bold subheading mb-4",
              attrs: { "two-line": "" },
            },
            [
              _c(
                "v-list-item-content",
                [_c("v-list-item-title", [_vm._v("TUTORIALES")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.getFrequentQuestions, function (frequentQuestion, i) {
        return _c(
          "div",
          { key: i, staticClass: "px-4 mb-10" },
          [
            _c("h4", [
              _c("span", [_vm._v(_vm._s(i + 1) + ". ")]),
              _vm._v("\n      " + _vm._s(frequentQuestion.question) + "\n    "),
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "font-weight-regular ma-3 grey--text text--darken-1",
              },
              [_vm._v("\n      " + _vm._s(frequentQuestion.detail) + "\n    ")]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "my-2 ml-3" }, [
              _vm._v("\n      " + _vm._s(frequentQuestion.answer) + "\n    "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ml-3" },
              [
                frequentQuestion.tutorial
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "black--text",
                        attrs: { dense: "", small: "", color: "accent" },
                        on: {
                          click: function ($event) {
                            return _vm.setTutorial({
                              tutorial: frequentQuestion.tutorial,
                            })
                          },
                        },
                      },
                      [_vm._v("\n        Ver tutorial\n      ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("v-divider", { staticClass: "mt-10" }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }